import { connect } from 'react-redux'
import { compose, setDisplayName, setPropTypes, withProps } from 'recompose'
import PropTypes from 'prop-types'
import { setCreateClientFrom } from 'src/actions/navigation'
import { selectBuyingReportRoute } from 'src/store/selectors/layout'

const BuyersLinkContainer = compose(
  setDisplayName('BuyersLinkContainer'),
  setPropTypes({
    affordability: PropTypes.number.isRequired,
    from: PropTypes.string
  }),
  connect(
    state => ({
      pathname: selectBuyingReportRoute(state)
    }),
    (dispatch, { from }) => ({
      onClick: () => dispatch(setCreateClientFrom(from))
    })
  ),
  withProps(({ affordability, pathname }) => ({
    to: {
      pathname,
      affordability
    }
  }))
)

export default BuyersLinkContainer
